module.exports = __webpack_public_path__ + "img/img_03_2.e8f66efa.png";